import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionDetailPage } from '@/modules/subscriptions/pages/SubscriptionDetailPage';

export const Route = createFileRoute('/dashboard/subscriptions/$subscriptionId/')({
  component: SubscriptionDetailPageRoute,
});

function SubscriptionDetailPageRoute() {
  const { subscriptionId } = Route.useParams();
  return <SubscriptionDetailPage subscriptionId={subscriptionId} />;
}
